import script from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawTotals.vue?vue&type=style&index=0&id=510fb8da&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510fb8da"]])

export default __exports__